import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=1f2208ac&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=ts&"
export * from "./Home.vue?vue&type=script&lang=ts&"
import style0 from "./Home.vue?vue&type=style&index=0&id=1f2208ac&prod&lang=scss&scoped=true&"
import style1 from "./Home.vue?vue&type=style&index=1&id=1f2208ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2208ac",
  null
  
)

export default component.exports